module.exports = __webpack_public_path__ + "static/start-ede22baf0a33301716545c13f706d2f5.png";